var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wansheng"},[_c('img',{attrs:{"src":"https://static1.kaixinyf.cn/img/lza62b033adde617832005187.png","alt":"logo"}}),_c('h3',[_vm._v("你的好友")]),_vm._m(0),_c('button',{attrs:{"id":"wan-sheng-download-button"},on:{"click":_vm.handleDownload}},[_vm._v("打开/下载 快音")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v("邀请你来"),_c('span',[_vm._v(" 快音 ")]),_vm._v("听歌看视频")])
}]

export { render, staticRenderFns }